import { Component, OnInit,  ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
declare var $: any;
import * as _ from 'lodash';
import { FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { Sh10Service } from 'src/app/services/sh10.service';
@Component({
  selector: 'app-sh10',
  templateUrl: './sh10.component.html',
  styleUrls: ['./sh10.component.css']
})
export class Sh10Component implements OnInit {

  sh10form: FormGroup;
  restrictTabflag: boolean;
  editParticularId: any;
  editParticularData: any;
  dateofpassingspecialresolutionModel: any;
  dateofclosingbbModel: any;
  dateofapprovalModel: any;
  datebbcompletedModel: any;
  dateofopeningbbofferModel: any;
  showrows: boolean;
  TodayDate: NgbDateStruct;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  newFieldArray: { id: number; title: string; }[];
  newFieldAttribute: any;
  holdingList: any;
  deleteholdingId: any;
  SetReferencetosecurity: any;
  SetCategoryofshares: any;
  Setmodebuyback: any;
  securityUpdate: boolean;
  updateRecordId: any;
  holdingListNew: any;
  disabledOnClick: boolean;

  @ViewChildren(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptionsOfdepositor: DataTables.Settings = {};
  masterDirectorList: any[];
  editList: any = [];
  addForm: FormGroup;
  addList: any = [];
  rows: FormArray;
  itemForm: FormGroup;
  depositForm: FormGroup;
  showIndividualYes: any;
  showBodyCorporateYes: any;
  showminorYesClick: boolean;
  dtTrigger: Subject<any> = new Subject();
  dtTriggerDeposit: Subject<any> = new Subject();
  dtTriggerdepositor: Subject<any> = new Subject();
  DepositDetailList: any[];
  depositor: any = [];
  DepositDetail: any[];
  public environmentSettings: any;
  depositorEditList: any[];
  depositorDetailsList: any[];
  globalDepositID: any;
  public isVisible: boolean = false;
  editRemarkId: any;
  depositorList: any = [];
  editForm: FormGroup;
  id: string = '';
  remarks = '';
  remarks1 = '';
  sh10addlist: any[];
  Amount: '';
  depoForm: FormGroup;
  depoList: any[];
  depositlist: any[];
  dtTriggerHolding: Subject<any> = new Subject();
  dtOptionsOfHolding: DataTables.Settings = {};
  addShareAndSecurityForm: FormGroup;
  addButton: boolean = true;
  deleteButton: boolean = true;

  constructor(private sh10service: Sh10Service, private activatedRoute: ActivatedRoute, private commonFunction: CommonFunction, private alert: AlertComponent, private router: Router, private fb: FormBuilder,
    private authAlert: AuthAlertComponent, private modalService: NgbModal, private route: ActivatedRoute, ) {


    this.addForm = this.fb.group({
    });

    this.rows = this.fb.array([]);
  }

  ngOnInit() {


    this.sh10form = new FormGroup({
      dateofpassingspecialresolution: new FormControl('', []),
      priceshares: new FormControl('', [Validators.pattern("^[0-9 /,.-]*$"), Validators.maxLength(100)]),
      dateofclosingbb: new FormControl('', []),
      dateofapproval: new FormControl('', [Validators.required]),
      amountshares: new FormControl('', [Validators.pattern("^[0-9 /,.-]*$"), Validators.maxLength(100)]),
      datebbcompleted: new FormControl('', []),
      specifiedsecurity: new FormControl('', [Validators.pattern("^[0-9 ,.-]*$"), Validators.maxLength(100)]),
      dateofopeningbboffer: new FormControl('', []),
      descriptionsh10: new FormControl('', [Validators.pattern("^[a-zA-Z0-9\n /,.&-]*$")])

    });

    this.activatedRoute.params.subscribe(params => {
      console.log('particularId : ' + params['particularId']);
      if (params['particularId'] != undefined) {
        this.restrictTabflag = true;
        this.editParticularId = params['particularId'];
        this.getsh10byID(this.editParticularId);
      } else {
        this.restrictTabflag = false;
      }
    });


    this.editForm = this.fb.group({

      'Referencetosecurity': [],
      'numberadd': [],
      'nameoflastholder': [],
      'Categoryofshares': [],
      'datebuyback': [],
      'numberofsecurityboughtback': [],
      'modebuyback': [],
      'nominalvaluesecurity': [],
      'pricesecurityboughtback': [],
      'datepayment': [],
      'amountpaidboughtbacksecurity': [],
      'Cumulativetotalsecurityboughtback': [],
      'dateofcancellation': [],
      'referencetoentryregistermember': [],
      'otherrelevant': [],
      'remarksadd': [],
    });

    this.addForm = new FormGroup({
      Referencetosecurity: new FormControl('', []),
      numberadd: new FormControl('', []),
      nameoflastholder: new FormControl('', []),
      Categoryofshares: new FormControl('', []),
      datebuyback: new FormControl('', []),
      numberofsecurityboughtback: new FormControl('', []),
      modebuyback: new FormControl('', []),
      nominalvaluesecurity: new FormControl('', []),
      pricesecurityboughtback: new FormControl('', []),
      datepayment: new FormControl('', []),
      amountpaidboughtbacksecurity: new FormControl('', []),
      Cumulativetotalsecurityboughtback: new FormControl('', []),
      dateofcancellation: new FormControl('', []),
      referencetoentryregistermember: new FormControl('', []),
      otherrelevant: new FormControl('', []),
      remarksadd: new FormControl('', []),
    });

    this.addForm.addControl('rows', this.rows);

    const control = <FormArray>this.rows
    for (let i = control.length - 1; i >= 0; i--) {
      control.removeAt(i);
    }


    this.getaddrowdetaillist(); {
      this.dtOptions = {
        destroy: true,
        pagingType: 'full_numbers',
        paging: true,
        pageLength: 50,
        stateSave: true,
        stateDuration: -1,
        search: true,
        order: [0, 'asc'],
        lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
        columnDefs: [{ orderable: false, targets: [7] }]
      };
    }

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };

    this.addShareAndSecurityForm = this.fb.group({
      newField: new FormArray([
      ]),
    });
    this.newFieldArray = [];

    this.dtOptionsOfHolding = {
      destroy: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: []

    };
    this.getHoldingList();
  }
  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh10list']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }


  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      // if ((ev.target.value + ev.key).length > 10) {
      //   ev.preventDefault();
      // }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getsh10byID(particularId) {
    this.sh10service.getupdatesh10(particularId).subscribe(response => {
      console.log("response", response);
      this.editParticularData = response.data[0];
      this.sh10form.controls.priceshares.setValue(this.editParticularData.priceshares);
      this.sh10form.controls.amountshares.setValue(this.editParticularData.amountshares);
      this.sh10form.controls.specifiedsecurity.setValue(this.editParticularData.specifiedsecurity);
      this.sh10form.controls.descriptionsh10.setValue(this.editParticularData.descriptionsh10);

      if (this.editParticularData.dateofpassingspecialresolution != null) {

        console.log("this.editParticularData.dateofpassingspecialresolution", this.editParticularData.dateofpassingspecialresolution);
        let dt = new Date(this.setFormatDate(this.editParticularData.dateofpassingspecialresolution));
        this.dateofpassingspecialresolutionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateofclosingbb != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateofclosingbb));
        this.dateofclosingbbModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateofapproval != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateofapproval));
        this.dateofapprovalModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.datebbcompleted != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.datebbcompleted));
        this.datebbcompletedModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateofopeningbboffer != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateofopeningbboffer));
        this.dateofopeningbbofferModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }


    });
  }






  getsh10list(_id): void {
    console.log(_id);
    this.sh10service.getsh10listdata(_id).subscribe(response => {
      console.log(response)
      this.id = response.data.Info._id;
      this.editRemarkId = response.data.Info._id;
      this.editForm.setValue({
        Referencetosecurity: response.data.Info.Referencetosecurity,
        numberadd: response.data.Info.numberadd,
        nameoflastholder: response.data.Info.nameoflastholder,
        Categoryofshares: response.data.Info.Categoryofshares,
        datebuyback: response.data.Info.datebuyback,
        numberofsecurityboughtback: response.data.Info.numberofsecurityboughtback,
        modebuyback: response.data.Info.modebuyback,
        nominalvaluesecurity: response.data.Info.nominalvaluesecurity,
        pricesecurityboughtback: response.data.Info.pricesecurityboughtback,
        datepayment: response.data.Info.datepayment,
        amountpaidboughtbacksecurity: response.data.Info.amountpaidboughtbacksecurity,
        Cumulativetotalsecurityboughtback: response.data.Info.Cumulativetotalsecurityboughtback,
        dateofcancellation: response.data.Info.dateofcancellation,
        referencetoentryregistermember: response.data.Info.referencetoentryregistermember,
        otherrelevant: response.data.Info.otherrelevant,
        remarksadd: response.data.Info.remarksadd,

      });
      $("#hello").modal("toggle");
    });
  }



  onFormSubmit(data: NgForm, _id) {

    this.sh10service.update(this.editRemarkId, data)
      .subscribe(response => {
        this.getaddrowdetaillist();
        $("#hello").modal("toggle");
        // let id = response['_id'];
        //  this.router.navigate(['/depositor-details', id]);
      }, (err) => {
        console.log(err);
      }
      );
  }

  deleterowsh10detail(_id) {
    this.sh10service.removedetails(_id)

      .subscribe(response => {

        if (response.status == 0) {
          this.DepositDetailList = [];
          this.getaddrowdetaillist();
          this.alert.success(' deleted successfully.')
        }
        else {
          this.alert.error('Oops, Something went wrong.')
        }

      });
  }

  generateOutput(id) {
    var object = {
      id: this.editParticularId,
      fromDate: null,
      toDate: null
    }
    this.sh10service.generateSh10Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.sh10service.downloadSh10File(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.sh10service.downloadSh10PdfFile(id, 'Single');
  }

  getaddrowdetaillist() {

    this.sh10addlist = [];
    // $("#depositorTable").DataTable().destroy();
    this.sh10service.getsh10detail()
      .subscribe(depositList => {

        this.sh10addlist = depositList.data;
        console.log("  console.log( this.DepositDetailList );", this.sh10addlist);
        this.dtTrigger.next();
      });
  }

  addNewFieldsModal() {
    //this.newFieldArray=[];
    this.resetFields();
    this.addButton = true;
    this.deleteButton = true;
    this.securityUpdate = false;
    $("#addNewForm").modal('toggle');
    this.addNewFields();
  }

  addNewFields() {
    var formArray: FormArray = <FormArray>this.addShareAndSecurityForm.controls.newField;
    var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);
  }

  resetFields() {
    var formArray: FormArray = <FormArray>this.addShareAndSecurityForm.controls.newField;
    const index = _.size(formArray.controls);
    console.log('index : ' + index);
    for (let i = index - 1; i >= 0; i--) {
      this.newFieldArray.splice(i, 1);
      var formArray = <FormArray>this.addShareAndSecurityForm.controls.newField;
      formArray.removeAt(i)
    }
    this.SetReferencetosecurity = '';
    this.SetCategoryofshares = '';
    this.Setmodebuyback = '';
  }

  removeField(index) {
    this.newFieldArray.splice(index, 1);
    var formArray = <FormArray>this.addShareAndSecurityForm.controls.newField;
    formArray.removeAt(index)
  }

  initialiseNewFieldArray(): FormGroup {
    return this.fb.group({
      Referencetosecurity: new FormControl('', []),
      numberadd: new FormControl('', [Validators.pattern("^[0-9 /,.-]*$"), Validators.maxLength(10)]),
      nameoflastholder: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /.,&-]*$"), Validators.maxLength(100)]),
      Categoryofshares: new FormControl('', []),
      datebuyback: new FormControl(null, []),
      numberofsecurityboughtback: new FormControl('', [Validators.pattern("^[0-9 ,.-]*$"), Validators.maxLength(10)]),
      modebuyback: new FormControl('', []),
      nominalvaluesecurity: new FormControl('', [Validators.pattern("^[0-9 ,.-]*$"), Validators.maxLength(10)]),
      pricesecurityboughtback: new FormControl('', [Validators.pattern("^[0-9 ,.-]*$"), Validators.maxLength(10)]),
      datepayment: new FormControl(null, []),
      amountpaidboughtbacksecurity: new FormControl('', [Validators.pattern("^[0-9 ,.-]*$"), Validators.maxLength(10)]),
      Cumulativetotalsecurityboughtback: new FormControl('', [Validators.pattern("^[0-9 ,.-]*$"), Validators.maxLength(20)]),
      dateofcancellation: new FormControl(null, []),
      referencetoentryregistermember: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /.,-]*$"), Validators.maxLength(100)]),
      otherrelevant: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /.,&-]*$"), Validators.maxLength(250)]),
      remarksadd: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /.,&-]*$"), Validators.maxLength(500)])
    })
  }

  getHoldingList() {
    this.holdingList = [];
    this.holdingListNew = []
    var Id = this.editParticularId;
    var securityName;
    this.sh10service.getsh10listdata(Id).subscribe(holdingList => {
      var list = holdingList.data.Info;
      this.holdingList = list.shareAndSecurities;

      list.shareAndSecurities.forEach(data => {
        if (data.Referencetosecurity == 'folionumber') {
          securityName = 'Folio number';
        } else if (data.Referencetosecurity == 'dpid') {
          securityName = 'DP Id';
        } else if (data.Referencetosecurity == 'clientidnumber') {
          securityName = 'Client ID number or certificate number';
        } else {
          securityName = '';
        }

        this.holdingListNew.push(
          {
            "Referencetosecurity": securityName,
            "numberadd": data.numberadd,
            "nameoflastholder": data.nameoflastholder,
            "_id": data._id
          });
      });

      console.log('this.holdingList =====> ' + JSON.stringify(this.holdingList));
      this.dtTriggerHolding.next();
    });
  }

  saveShareAndSecurity() {
    // var object = {
    //   particularId: this.editParticularId,
    //   data:this.addShareAndSecurityForm.controls.newField.value
    // };
    this.disabledOnClick = true;
    var addSecurityFormData = [];
    for (var i = 0; i < this.addShareAndSecurityForm.controls.newField.value.length; i++) {
      addSecurityFormData.push({
        Referencetosecurity: this.addShareAndSecurityForm.controls.newField.value[i].Referencetosecurity,
        numberadd: this.addShareAndSecurityForm.controls.newField.value[i].numberadd,
        nameoflastholder: this.addShareAndSecurityForm.controls.newField.value[i].nameoflastholder,
        Categoryofshares: this.addShareAndSecurityForm.controls.newField.value[i].Categoryofshares,
        datebuyback: this.setDate(this.addShareAndSecurityForm.controls.newField.value[i].datebuyback),
        numberofsecurityboughtback: this.addShareAndSecurityForm.controls.newField.value[i].numberofsecurityboughtback,
        modebuyback: this.addShareAndSecurityForm.controls.newField.value[i].modebuyback,
        nominalvaluesecurity: this.addShareAndSecurityForm.controls.newField.value[i].nominalvaluesecurity,
        pricesecurityboughtback: this.addShareAndSecurityForm.controls.newField.value[i].pricesecurityboughtback,
        datepayment: this.setDate(this.addShareAndSecurityForm.controls.newField.value[i].datepayment),
        amountpaidboughtbacksecurity: this.addShareAndSecurityForm.controls.newField.value[i].amountpaidboughtbacksecurity,
        Cumulativetotalsecurityboughtback: this.addShareAndSecurityForm.controls.newField.value[i].Cumulativetotalsecurityboughtback,
        dateofcancellation: this.setDate(this.addShareAndSecurityForm.controls.newField.value[i].dateofcancellation),
        referencetoentryregistermember: this.addShareAndSecurityForm.controls.newField.value[i].referencetoentryregistermember,
        otherrelevant: this.addShareAndSecurityForm.controls.newField.value[i].otherrelevant,
        remarksadd: this.addShareAndSecurityForm.controls.newField.value[i].remarksadd
      });
    }

    var object = {
      particularId: this.editParticularId,
      amountshares: this.editParticularData.amountshares,
      specifiedsecurity: this.editParticularData.specifiedsecurity,
      descriptionsh10: this.editParticularData.descriptionsh10,
      dateofpassingspecialresolution: this.editParticularData.dateofpassingspecialresolution,
      dateofclosingbb: this.editParticularData.dateofclosingbb,
      dateofapproval: this.editParticularData.dateofapproval,
      datebbcompleted: this.editParticularData.datebbcompleted,
      dateofopeningbboffer: this.editParticularData.dateofopeningbboffer,
      shareAndSecurities: addSecurityFormData
    };
    //console.log("newField", object);
    this.sh10service.addrowdetailsh10(object).subscribe(response => {
      this.disabledOnClick = false;
      console.log("response :", response);
      if (response.status == 0) {
        $("#detailsOfHoldinglistTable").DataTable().destroy();
        this.newFieldArray = [];
        this.alert.success(response.message);
      } else {
        $("#detailsOfHoldinglistTable").DataTable().destroy();
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }
      this.getHoldingList();
      $("#addNewForm .close").click()
    })
  }

  updateShareAndSecurity(UpdateRecordID) {
    //var newObj=this.addShareAndSecurityForm.controls.newField.value;
    this.disabledOnClick = true;
    var newObj = [];
    for (var i = 0; i < this.addShareAndSecurityForm.controls.newField.value.length; i++) {
      newObj.push({
        Referencetosecurity: this.addShareAndSecurityForm.controls.newField.value[i].Referencetosecurity,
        numberadd: this.addShareAndSecurityForm.controls.newField.value[i].numberadd,
        nameoflastholder: this.addShareAndSecurityForm.controls.newField.value[i].nameoflastholder,
        Categoryofshares: this.addShareAndSecurityForm.controls.newField.value[i].Categoryofshares,
        datebuyback: this.setDate(this.addShareAndSecurityForm.controls.newField.value[i].datebuyback),
        numberofsecurityboughtback: this.addShareAndSecurityForm.controls.newField.value[i].numberofsecurityboughtback,
        modebuyback: this.addShareAndSecurityForm.controls.newField.value[i].modebuyback,
        nominalvaluesecurity: this.addShareAndSecurityForm.controls.newField.value[i].nominalvaluesecurity,
        pricesecurityboughtback: this.addShareAndSecurityForm.controls.newField.value[i].pricesecurityboughtback,
        datepayment: this.setDate(this.addShareAndSecurityForm.controls.newField.value[i].datepayment),
        amountpaidboughtbacksecurity: this.addShareAndSecurityForm.controls.newField.value[i].amountpaidboughtbacksecurity,
        Cumulativetotalsecurityboughtback: this.addShareAndSecurityForm.controls.newField.value[i].Cumulativetotalsecurityboughtback,
        dateofcancellation: this.setDate(this.addShareAndSecurityForm.controls.newField.value[i].dateofcancellation),
        referencetoentryregistermember: this.addShareAndSecurityForm.controls.newField.value[i].referencetoentryregistermember,
        otherrelevant: this.addShareAndSecurityForm.controls.newField.value[i].otherrelevant,
        remarksadd: this.addShareAndSecurityForm.controls.newField.value[i].remarksadd
      });
    }
    newObj[0]["_id"] = UpdateRecordID;

    if (UpdateRecordID) {
      var object = {
        particularId: this.editParticularId,
        updateRecId: UpdateRecordID,
        data: newObj
      };
      //console.log("Update newField", object);
      this.sh10service.editrowdetailsh10(object).subscribe(response => {
        this.disabledOnClick = false;
        //console.log("response :", response);
        if (response.status == 0) {
          $("#detailsOfHoldinglistTable").DataTable().destroy();
          this.newFieldArray = [];
          this.alert.success(response.message);
        } else {
          $("#detailsOfHoldinglistTable").DataTable().destroy();
          if (response.err_fields) {
            this.alert.error(response.err_fields + ' fields are required or invalid.');
          } else {
            this.alert.error(response.message);
          }
        }
        this.getHoldingList();
        $("#addNewForm .close").click();
      })
    }
  }

  editShareAndSecurityDetails(recordId) {
    //this.newFieldArray=[];
    this.resetFields();
    var Id = this.editParticularId;
    this.sh10service.getsh10listdata(Id).subscribe(response => {
      //console.log(JSON.stringify(response));
      var responseList = response.data.Info;
      responseList.shareAndSecurities.forEach(data => {
        if (data._id == recordId) {
          $("#addNewForm").modal('toggle');
          this.securityUpdate = true;
          this.addNewFields();
          this.addButton = false;
          this.deleteButton = false;
          //console.log(data.numberadd);
          var formArray: FormArray = <FormArray>this.addShareAndSecurityForm.controls.newField;
          var formGroup: FormGroup = <FormGroup>formArray.controls[0];

          // formGroup.get('Referencetosecurity').setValue(data.Referencetosecurity);
          // this.SetReferencetosecurity=data.Referencetosecurity;
          // formGroup.get('numberadd').setValue(data.numberadd);
          // formGroup.get('nameoflastholder').setValue(data.nameoflastholder);
          // formGroup.get('Categoryofshares').setValue(data.Categoryofshares);
          // this.SetCategoryofshares=data.Categoryofshares;
          // formGroup.get('datebuyback').setValue(this.setDateFormat(data.datebuyback));
          // formGroup.get('numberofsecurityboughtback').setValue(data.numberofsecurityboughtback);
          // formGroup.get('modebuyback').setValue(data.modebuyback);
          // this.Setmodebuyback=data.modebuyback;
          // formGroup.get('nominalvaluesecurity').setValue(data.nominalvaluesecurity);
          // formGroup.get('pricesecurityboughtback').setValue(data.pricesecurityboughtback);
          // formGroup.get('datepayment').setValue(this.setDateFormat(data.datepayment));
          // formGroup.get('amountpaidboughtbacksecurity').setValue(data.amountpaidboughtbacksecurity);
          // formGroup.get('Cumulativetotalsecurityboughtback').setValue(data.Cumulativetotalsecurityboughtback);
          // formGroup.get('dateofcancellation').setValue(this.setDateFormat(data.dateofcancellation));
          // formGroup.get('referencetoentryregistermember').setValue(data.referencetoentryregistermember);
          // formGroup.get('otherrelevant').setValue(data.otherrelevant);
          // formGroup.get('remarksadd').setValue(data.remarksadd);

          formGroup.get('Referencetosecurity').setValue(data.Referencetosecurity);
          this.SetReferencetosecurity = data.Referencetosecurity;
          formGroup.get('numberadd').setValue(data.numberadd);
          formGroup.get('nameoflastholder').setValue(data.nameoflastholder);
          formGroup.get('Categoryofshares').setValue(data.Categoryofshares);
          this.SetCategoryofshares = data.Categoryofshares;

          if (data.datebuyback != null) {
            let dt = new Date(data.datebuyback);
            var datebuybackNew = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            formGroup.get('datebuyback').setValue(datebuybackNew);
          } else {
            formGroup.get('datebuyback').setValue(null);
          }

          formGroup.get('numberofsecurityboughtback').setValue(data.numberofsecurityboughtback);
          formGroup.get('modebuyback').setValue(data.modebuyback);
          this.Setmodebuyback = data.modebuyback;
          formGroup.get('nominalvaluesecurity').setValue(data.nominalvaluesecurity);
          formGroup.get('pricesecurityboughtback').setValue(data.pricesecurityboughtback);

          if (data.datepayment != null) {
            let dt = new Date(data.datepayment);
            var datepaymentNew = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            formGroup.get('datepayment').setValue(datepaymentNew);
          } else {
            formGroup.get('datepayment').setValue(null);
          }

          formGroup.get('amountpaidboughtbacksecurity').setValue(data.amountpaidboughtbacksecurity);
          formGroup.get('Cumulativetotalsecurityboughtback').setValue(data.Cumulativetotalsecurityboughtback);

          if (data.dateofcancellation != null) {
            let dt = new Date(data.dateofcancellation);
            var dateofcancellationNew = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            formGroup.get('dateofcancellation').setValue(dateofcancellationNew);
          } else {
            formGroup.get('dateofcancellation').setValue(null);
          }

          formGroup.get('referencetoentryregistermember').setValue(data.referencetoentryregistermember);
          formGroup.get('otherrelevant').setValue(data.otherrelevant);
          formGroup.get('remarksadd').setValue(data.remarksadd);
          this.updateRecordId = recordId;
        }
      });
    });
  }

  setDateFormat(dateValue) {
    // mm/dd/yyyy
    if (dateValue == null) { return ""; }
    const currentDate = new Date(dateValue);
    return currentDate.toISOString().substring(0, 10);
  }

  confirmDelete(_id) {
    this.deleteholdingId = _id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteholdingdetail() {
    var Id = this.editParticularId;
    this.sh10service.deleteShareAndSecurityDetails(this.deleteholdingId, Id).subscribe(response => {
      if (response.status == 0) {
        $("#detailsOfHoldinglistTable").DataTable().destroy();
        $("#deleteConfirm").modal('toggle');
        this.alert.success(response.message);
      } else {
        this.alert.error(response.message);
      }
      this.getHoldingList();
    });
  }


  onAddRow() {
    this.showrows = true;
    this.rows.push(this.createItemFormGroup());

  }
  onRemoveRow(rowIndex: number) {

    this.rows.removeAt(rowIndex);
  }


  createItemFormGroup(): FormGroup {
    return this.fb.group({
      Referencetosecurity: null,
      numberadd: null,
      nameoflastholder: null,
      Categoryofshares: null,
      datebuyback: null,
      numberofsecurityboughtback: null,
      modebuyback: null,
      nominalvaluesecurity: null,
      pricesecurityboughtback: null,
      datepayment: null,
      amountpaidboughtbacksecurity: null,
      Cumulativetotalsecurityboughtback: null,
      dateofcancellation: null,
      referencetoentryregistermember: null,
      otherrelevant: null,
      remarksadd: null,
    });
  }

  onSave() {
    console.log(this.rows.value)
    console.log("this.addForm", this.rows.value)
    var depositorObjects = {
      Referencetosecurity: this.rows.value,
      numberadd: this.rows.value,
      nameoflastholder: this.rows.value,
      Categoryofshares: this.rows.value,
      datebuyback: this.rows.value,
      numberofsecurityboughtback: this.rows.value,
      modebuyback: this.rows.value,
      nominalvaluesecurity: this.rows.value,
      pricesecurityboughtback: this.rows.value,
      datepayment: this.rows.value,
      amountpaidboughtbacksecurity: this.rows.value,
      Cumulativetotalsecurityboughtback: this.rows.value,
      dateofcancellation: this.rows.value,
      referencetoentryregistermember: this.rows.value,
      otherrelevant: this.rows.value,
      remarksadd: this.rows.value,
    }
    this.sh10service.addrowdetailsh10(depositorObjects).subscribe(response => {
      console.log("response", response);
      // this.addList = response.addList;
    })
  }
  submitted = false;
  onSubmit() { this.submitted = true; }

  minorYesClick() {
    this.showminorYesClick = true;
  }
  showminorNoClick() {
    this.showminorYesClick = false;
  }

  loadDepositorById(depositorId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['depositordetails','edit',depositorId]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/depositordetails/edit/', depositorId]);
  }




  savesh10Entry() {
    this.disabledOnClick = true;

    console.log("function is getting called");
    console.log("this.sh10form", this.sh10form)
    console.log("this.sh10form.value", this.sh10form.value)

    var sh10value = {
      dateofpassingspecialresolution: this.setDate(this.sh10form.controls.dateofpassingspecialresolution.value),
      priceshares: this.sh10form.controls.priceshares.value,
      dateofclosingbb: this.setDate(this.sh10form.controls.dateofclosingbb.value),
      dateofapproval: this.setDate(this.sh10form.controls.dateofapproval.value),
      amountshares: this.sh10form.controls.amountshares.value,
      datebbcompleted: this.setDate(this.sh10form.controls.datebbcompleted.value),
      specifiedsecurity: this.sh10form.controls.specifiedsecurity.value,
      dateofopeningbboffer: this.setDate(this.sh10form.controls.dateofopeningbboffer.value),
      descriptionsh10: this.sh10form.controls.descriptionsh10.value,
    }

    this.sh10service.sh10service(sh10value).subscribe(response => {
      this.disabledOnClick = false;
      console.log("response component in oninit", response);
      if (response.status == 0) {
        console.log("response.data._id", response.data.dataList._id);

        this.alert.successWithOk("SH-10 details added successfully.", 'sh-10/edit/' + response.data.dataList._id);
      } else {
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }

    })
  }

  updatelatesh10() {
    this.disabledOnClick = true;
    var object = {
      dateofpassingspecialresolution: this.setDate(this.sh10form.controls.dateofpassingspecialresolution.value),
      priceshares: this.sh10form.controls.priceshares.value,
      dateofclosingbb: this.setDate(this.sh10form.controls.dateofclosingbb.value),
      dateofapproval: this.setDate(this.sh10form.controls.dateofapproval.value),
      amountshares: this.sh10form.controls.amountshares.value,
      datebbcompleted: this.setDate(this.sh10form.controls.datebbcompleted.value),
      specifiedsecurity: this.sh10form.controls.specifiedsecurity.value,
      dateofopeningbboffer: this.setDate(this.sh10form.controls.dateofopeningbboffer.value),
      descriptionsh10: this.sh10form.controls.descriptionsh10.value,
    }
    this.sh10service.updateeditsh10(object, this.editParticularId).subscribe(response => {
      this.disabledOnClick = false;

      console.log(" this.editParticularId0", this.editParticularId);
      if (response.status == 0) {
        this.alert.success("SH-10 details updated successfully.");
      } else {
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }

    });
  }

}
